// extracted by mini-css-extract-plugin
export default {"drawer":"MarketingMaterialDrawer_drawer__rHpV8"};